import { render, staticRenderFns } from "./SoldToday.vue?vue&type=template&id=38215408"
import script from "./SoldToday.vue?vue&type=script&lang=js"
export * from "./SoldToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports